module.exports = __webpack_public_path__ + "img/upload-sample-wrong.6804e9aa.png";